import cn from 'classnames';
import React, { ReactNode } from 'react';
import { Flex } from '../Flex/Flex';
import './Toolbar.css';

/**
 * @deprecated Use {@link OverflowToolbar} instead. The plain `Toolbar` only wraps
 * its children in a flex row and truncates action labels with an ellipsis when space
 * runs out. `OverflowToolbar` collapses overflowing actions into a "more actions"
 * menu instead. New code should not use `Toolbar`.
 */
interface ToolbarProps {
  className?: string;
  children?: ReactNode;
}

/**
 * @deprecated Use {@link OverflowToolbar} instead — it collapses actions into a
 * "more actions" menu when space is tight rather than truncating their labels.
 * Kept for backward compatibility with existing usages.
 */
export const Toolbar: React.FC<ToolbarProps> = ({ className, children }) => {
  return (
    <Flex align="center" gap="12px" className={cn('toolbar', className)}>
      {children}
    </Flex>
  );
};
